module.exports = __webpack_public_path__ + "img/1.909af221.png";